import React from "react"
import { graphql, Link } from "gatsby"
import { Box } from "theme-ui"
import CommonTemplate from "templates/common-template"
import CompanyLogos from "components/company-logos"
import Testimonials from "components/lists/testimonials-list"
import styled from "@emotion/styled"

const WhyChooseUs = styled.div`
    figure.image.image-style-align-right.image_resized {
        display: inline-block;
        position: relative;
        width: 100px !important;
        height: 100px;
        overflow: hidden;
        border-radius: 50%;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        figure.image.image-style-align-right.image_resized {
            margin: 0;
            margin-top: -1rem;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        /* 8 */
        figure.image.image-style-align-right.image_resized {
            margin-left: 1rem;
            margin-top: 0;
            width: 75px !important;
            height: 75px;
        }
    }
`

// markup
const IndexPage = ({ location, data, pageContext }) => {
    let customJsx = null
    if (pageContext.slug === "eip-our-companies") {
        customJsx = <CompanyLogos />
    } else if (pageContext.slug === "eip-testimonials") {
        customJsx = <Testimonials />
    } else if (pageContext.slug === "eip-our-facilities") {
        customJsx = (
            <Box sx={{ marginTop: "1rem" }}>
                <p>
                    Book a <Link to="/contact">tour</Link> to experience our
                    facilities and learning environment firsthand.
                </p>
            </Box>
        )
    }
    const arrData = {
        location,
        data,
        bgColor:
            "linear-gradient(90deg, #a8dee0 25%, #b2e2e3 25%, #b2e2e3 50%, #a8dee0 50%, #a8dee0 75%, #b2e2e3 75%, #b2e2e3 100%)",
        galleryMinWidth: "40%", //default 0
        customElement: customJsx,
        // breadcrums // allow null
    }

    if (pageContext.slug === "eip-why-choose-us") {
        return (
            <WhyChooseUs>
                <CommonTemplate {...arrData} />
            </WhyChooseUs>
        )
    } else {
        return <CommonTemplate {...arrData} />
    }
}

export default IndexPage

export const query = graphql`
    query AboutUsQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: $slug }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
            }
        }
    }
`
